import { typographyVariants } from '@mint-lib/tw-components';
import { ProgressLinear } from '@mint-lib/tw-components/patterns';

import { Tooltip } from './Tooltip.jsx';

type Props = Readonly<{
  value: number;
  total: number;
  tooltip?: string;
}>;

export function LimitProgressBar({ value, total, tooltip = '' }: Props) {
  return (
    <Tooltip description={tooltip} side="top">
      <div className="flex items-center gap-2">
        <ProgressLinear className="w-[78px]" value={(value / total) * 100} />
        <span
          className={typographyVariants({
            variant: 'caption1',
            className: 'text-text-secondary',
          })}
        >
          {`${value}/${total}`}
        </span>
      </div>
    </Tooltip>
  );
}
